import { getProgramData } from '~shared/api/single-program-data/single-program-data'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'

// ─── Default data ─────────────────────────────────────────────────────────────

const DEFAULT_ITEMS = [
  'Владеть основами профессиональной диагностики и профессионального развития',
  'Проводить качественную психодиагностику',
  'Оказывать психологическую помощь личности по разрешению внутриличностных проблем',
  'Понимать особенности диагностики психического развития людей разного возраста',
  'Разбираться в психологии личности',
  'Понимать психологию труда, инженерную психологию и эргономику'
]
// ─── Component ────────────────────────────────────────────────────────────────

export const WhatWillYouLearnSection = ({
  program
}: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const items =
    program?.whatWillYouLearn && program?.whatWillYouLearn.length > 0
      ? program?.whatWillYouLearn.map(el => ({
          name: el.name ?? '',
          description: el.description
        }))
      : DEFAULT_ITEMS.map(text => ({ name: text, description: null }))

  const accentColor = program?.faculty?.color ?? '#3A52EE'

  return (
    <section className='py-[56px] 2lg:py-[80px]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>
        <h2 className='text-[32px] md:text-[40px] 2lg:text-[48px] font-medium mb-[32px] 2lg:mb-[48px]'>
          Чему вы научитесь?
        </h2>

        <ul className='flex flex-wrap gap-[16px]'>
          {items.map((item, idx) => (
            <li
              key={`WhatWillYouLearn__items__item--${idx + 1}`}
              className='flex items-start gap-[12px] md:min-w-[40%] break-words p-[24px] rounded-[16px] bg-[#F2F2F2] flex-1'>
              <span
                className='w-[12px] h-[12px] rounded-full shrink-0 translate-y-[4px]'
                style={{ backgroundColor: accentColor }}
              />
              <p className='text-[16px] 2lg:text-[18px] leading-[140%]'>
                {item.name
                  ? replacePrepositionsWhitespaces(item?.name ?? '')
                  : null}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
